import React, { FC, useState } from 'react';
import { OrgChangeButton, OrgChangeTitle } from './ChangeOrgDrop.styles';
import FlexibleDropdown, { IDropdownItem } from '@/HOC/FlexibleDropdown/FlexibleDropdown';
import { useOrganizations } from '@/hooks';
import { useAuth } from '@/hooks/useAuth';

interface IChangeOrgDrop {
  anchor?: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
  width?: string;
}

const ChangeOrgDrop: FC<IChangeOrgDrop> = ({ anchor, positionX, positionY, width }) => {
  const [activeIcon, setActiveIcon] = useState(false);
  const { switchOrganization } = useAuth();
  const { organizations, currentOrganization, changeOrganization } = useOrganizations();

  if (!currentOrganization) return null;

  const handleOrgSelect = (org: IDropdownItem) => {
    // if (org.id === currentOrganization.id) return;
    switchOrganization(org.id);
  };

  return (
    <FlexibleDropdown
      activeTile={{ key: 'name', value: currentOrganization.name }}
      items={organizations}
      setActiveIcon={setActiveIcon}
      getSelectedItem={handleOrgSelect}
      {...{ anchor, positionX, positionY, width }}
    >
      <OrgChangeButton data-testId="orgIconButton" active={activeIcon}>
        <OrgChangeTitle>{currentOrganization.name}</OrgChangeTitle>
      </OrgChangeButton>
    </FlexibleDropdown>
  );
};

export default ChangeOrgDrop;
